import { ClientService } from "../../shared/services/client.service";
import { PaginatedResultsLoaderFactory } from "../../shared/services/pagination-results-loader-factory.service";
import { AuthService } from "../../login/services/auth.service";
var ClientSearchService = /** @class */ (function () {
    function ClientSearchService(_clientService, _paginationFactory, authService) {
        var _this = this;
        this._clientService = _clientService;
        this._paginationFactory = _paginationFactory;
        this.authService = authService;
        this._showAllUsers = false;
        this._clients = [];
        // when we get a new client let's make sure the client always displays when a user is added.
        this._clientSubscription = this._clientService.getClientObservable().subscribe(function (c) {
            if (!c) {
                // try doing this differently.
                return; // skip any invalid input
            }
            if (_this.hasClientInResults(c)) {
                _this.updateClient(c);
            }
            else {
                _this.handleNewClient(c);
            }
        });
        this._userSubscription = this.authService.getLoginState().subscribe(function (state) {
            if (!state.isLoggedIn) {
                _this.clearSearch();
            }
        });
        this.restoreSearchSettings();
    }
    ClientSearchService.prototype.restoreSearchSettings = function () {
        if (localStorage) {
            var clientSearchData = localStorage.getItem('ClientSearchService');
            if (clientSearchData !== null) {
                try {
                    var data = JSON.parse(clientSearchData);
                    if (data.hasOwnProperty('_showAllUsers')) {
                        this._showAllUsers = data._showAllUsers === true;
                    }
                    if (data.hasOwnProperty('_exactMatch')) {
                        this._exactMatch = data._exactMatch === true;
                    }
                }
                catch (error) {
                    console.error("Failed to extract ClientSearchService data", error);
                }
            }
        }
    };
    ClientSearchService.prototype.saveSearchSettings = function () {
        if (localStorage) {
            var clientSearchData = {
                _showAllUsers: this._showAllUsers,
                _exactMatch: this._exactMatch
            };
            try {
                localStorage.setItem("ClientSearchService", JSON.stringify(clientSearchData));
            }
            catch (error) {
                console.error("Failed to save ClientSearchService data", error);
            }
        }
    };
    ClientSearchService.prototype.ngOnDestroy = function () {
        this._userSubscription.unsubscribe();
        this._clientSubscription.unsubscribe();
    };
    Object.defineProperty(ClientSearchService.prototype, "SearchValue", {
        get: function () {
            return this._searchValue;
        },
        set: function (v) {
            this._searchValue = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClientSearchService.prototype, "ShowAllUsers", {
        get: function () {
            return this._showAllUsers;
        },
        set: function (v) {
            this._showAllUsers = v;
            this.saveSearchSettings();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClientSearchService.prototype, "ExactMatch", {
        get: function () {
            return this._exactMatch;
        },
        set: function (v) {
            this._exactMatch = v;
            this.saveSearchSettings();
        },
        enumerable: true,
        configurable: true
    });
    ClientSearchService.prototype.clearSearch = function () {
        this._resultsLoader = null;
        this._searchUser = null;
        this._searchValue = {};
        this._clients = [];
    };
    ClientSearchService.prototype.hasClientInResults = function (c) {
        var id = c.id || null;
        return this._clients.find(function (c) { return c.id == id; }) != null;
    };
    ClientSearchService.prototype.updateClient = function (c) {
        var id = c.id || null;
        var index = this._clients.findIndex(function (c) { return c.id == id; });
        if (this._searchUser && c.user.id != this._searchUser.id) {
            this._clients.splice(index, 1);
        }
        else {
            this._clients[index] = c;
        }
    };
    ClientSearchService.prototype.handleNewClient = function (c) {
        if (this._searchValue != null) {
            this.search(this._searchValue, this._searchUser);
        }
        else {
            this._clients.unshift(c);
        }
    };
    ClientSearchService.prototype.search = function (search, user) {
        var _this = this;
        this.clearSearch();
        this._searchUser = user;
        this._searchValue = search;
        var queryFunction = this._clientService.searchClientList.bind(this._clientService, search, user);
        this._resultsLoader = this._paginationFactory.getResultsLoader(queryFunction);
        return this._resultsLoader.getResults()
            .then(function (results) {
            _this._clients = results;
            return results;
        });
    };
    ClientSearchService.prototype.hasMoreResults = function () {
        return this._resultsLoader.hasMoreResults();
    };
    ClientSearchService.prototype.loadMore = function () {
        var _this = this;
        // load more results
        return this._resultsLoader.loadMore()
            .then(function (results) {
            console.log(results);
            _this._clients = results;
            return results;
        });
    };
    ClientSearchService.prototype.getClientList = function (user) {
        var _this = this;
        this._searchUser = user;
        if (!this._resultsLoader) {
            var queryFunction = this._clientService.getClientList.bind(this._clientService, user);
            this._resultsLoader = this._paginationFactory.getResultsLoader(queryFunction);
            return this._resultsLoader.getResults().then(function (clients) {
                _this._clients = clients;
                return clients;
            });
        }
        else {
            return Promise.resolve(this._clients);
        }
    };
    return ClientSearchService;
}());
export { ClientSearchService };



// WEBPACK FOOTER //
// ./src/app/admin/services/client-search.service.ts.pre-build-optimizer.js